module.exports = {"340722106":"横埠镇","340722107":"项铺镇","340722108":"钱桥镇","340722109":"麒麟镇","340722110":"义津镇","340722111":"浮山镇","340722112":"会宫镇","340722113":"官埠桥镇","340722114":"钱铺镇","340722115":"金社镇","340722116":"白柳镇","340722117":"雨坛镇","340722118":"枞阳镇","340722119":"欧山镇","340722120":"汤沟镇","340722205":"白梅乡","340722400":"枞阳经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340722.json
// module id = 1196
// module chunks = 0